/**
 * Holds hardcoded string values that need to be segmented by language,
 * and which are not part of the TC data set.
 * 
 * These get merged into `Strings`.
 *
 * Be sure the #map's property names do not 'collide' w/ the TC string names.
 */
export default class NonTcStrings {

  static #map = {
    "playstore_badge_filename": {
      "en": "badge-googleplay_en.png",
      "es": "badge-googleplay_es.png",
      "hi": "badge-googleplay_hi.png",
      "id": "badge-googleplay_id.png",
      "ms": "badge-googleplay_ms.png",
      "pt": "badge-googleplay_pt.png",
      "te": "badge-googleplay_te.png",
      "th": "badge-googleplay_th.png",
      "vi": "badge-googleplay_vi.png",
      "bn": "badge-googleplay_en.png",
      "ta": "badge-googleplay_en.png",
      "kn": "badge-googleplay_en.png"
    },
    "appstore_badge_filename": {
      "en": "badge-appstore_en.png",
      "es": "badge-appstore_es.png",
      "hi": "badge-appstore_hi.png",
      "id": "badge-appstore_id.png",
      "ms": "badge-appstore_ms.png",
      "pt": "badge-appstore_pt.png",
      "te": "badge-appstore_te.png",
      "th": "badge-appstore_th.png",
      "vi": "badge-appstore_vi.png",
      "bn": "badge-appstore_en.png",
      "ta": "badge-appstore_en.png",
      "kn": "badge-appstore_en.png"
    },
    "playstore_app_url": {
      "en": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=en",
      "es": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=es",
      "hi": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=hi",
      "id": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=id",
      "ms": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=ms",
      "pt": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=pt",
      "te": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=te",
      "th": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=th",
      "vi": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=vi",
      "bn": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=bn",
      "ta": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=ta",
      "kn": "https://play.google.com/store/apps/details?id=com.google.android.apps.primer&hl=kn"
    },
    "appstore_app_url": {
      "en": "https://apps.apple.com/us/app/google-primer/id918628107",
      "es": "https://apps.apple.com/es/app/google-primer/id918628107",
      "hi": "https://apps.apple.com/us/app/google-primer/id918628107",
      "id": "https://apps.apple.com/id/app/google-primer/id918628107",
      "ms": "https://apps.apple.com/ms/app/google-primer/id918628107",
      "pt": "https://apps.apple.com/pt/app/google-primer/id918628107",
      "te": "https://apps.apple.com/us/app/google-primer/id918628107",
      "th": "https://apps.apple.com/th/app/google-primer/id918628107",
      "vi": "https://apps.apple.com/vn/app/google-primer/id918628107",
      "bn": "https://apps.apple.com/bn/app/google-primer/id918628107",
      "ta": "https://apps.apple.com/app/apple-store/id918628107",
      "kn": "https://apps.apple.com/kn/app/google-primer/id918628107"
    },
    "privacy_policy_url": {
      "en": "https://policies.google.com/privacy?hl=en",
      "es": "https://policies.google.com/privacy?hl=es",
      "hi": "https://policies.google.com/privacy?hl=hi",
      "id": "https://policies.google.com/privacy?hl=id",
      "ms": "https://policies.google.com/privacy?hl=ms",
      "pt": "https://policies.google.com/privacy?hl=pt",
      "te": "https://policies.google.com/privacy?hl=te",
      "th": "https://policies.google.com/privacy?hl=th",
      "vi": "https://policies.google.com/privacy?hl=vi",
      "bn": "https://policies.google.com/privacy?hl=bn",
      "ta": "https://policies.google.com/privacy?hl=ta",
      "kn": "https://policies.google.com/privacy?hl=kn"
    }
  };

  static get map() {
    return NonTcStrings.#map;
  }
}

/*
    "thing": {
      "en": "",
      "es": "",
      "hi": "",
      "id": "",
      "ms": "",
      "pt": "",
      "te": "",
      "th": "",
      "vi": "",
      "bn": "",
      "ta": "",
      "kn": ""
    }
 */
